import React from 'react'

import { type Question } from '~/hooks/useSurveyQuery'
import { type GroupAndAll } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { buildMatrixAnswersData, type MatrixAnswerData } from '../utils'

import { useMapQuestionsDiff } from './useMapQuestionsDiff'
import { useTotalData } from './useTotalData'

export const useMatrixAnswersData = (
  question: Question,
  group: GroupAndAll,
): MatrixAnswerData[] => {
  const questionQueryData = useAtomValueContext('questionQueryData')
  const mapQuestionsDiff = useMapQuestionsDiff(question)
  const totalData = useTotalData()

  return React.useMemo(
    () =>
      buildMatrixAnswersData({
        group,
        mapQuestionsDiff,
        questionId: question.question_id,
        questions: questionQueryData?.questions ?? [],
        results: questionQueryData?.results ?? [],
        totalCount: totalData.counts[group],
      }),
    [
      group,
      mapQuestionsDiff,
      question.question_id,
      questionQueryData?.questions,
      questionQueryData?.results,
      totalData.counts,
    ],
  )
}
